import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { translations } from '../../i18n'
import Loader from '../../components/Loader'

function PublicationsSection() {
  const { lang } = useSelector(s => s.rootReducer.langRed)
  const T = translations[lang]
  const { loading, byType = {} } = useSelector(s => s.rootReducer.publicationsRed)
  const [activeTab, setActiveTab] = useState('journal')

  if (loading) return <section id='publications' className='fc-section bg-alt'><Container><Loader /></Container></section>

  const tabs = Object.keys(byType)
  const current = byType[activeTab] || []

  return (
    <section id='publications' className='fc-section bg-alt'>
      <Container>
        <h2 className='section-title'>{T.sections.publications}</h2>

        <div className='pub-tabs'>
          {tabs.map(type => (
            <button
              key={type}
              className={`pub-tab-btn ${activeTab === type ? 'active' : ''}`}
              onClick={() => setActiveTab(type)}
            >
              {T.pub_types[type] || type} ({byType[type]?.length || 0})
            </button>
          ))}
        </div>

        {current.map(pub => (
          <div className='pub-card' key={pub.id}>
            <div className='d-flex justify-content-between align-items-start'>
              <div className='pub-title'>{pub.title}</div>
              <span className='pub-year ms-2 flex-shrink-0'>{pub.year}</span>
            </div>
            <div className='pub-authors'>{pub.authors}</div>
            <div className='pub-venue'>
              {pub.venue}
              {pub.volume_pages ? ` — ${pub.volume_pages}` : ''}
            </div>
          </div>
        ))}
      </Container>
    </section>
  )
}

export default PublicationsSection
